module.exports = __webpack_public_path__ + "img/consultoria_4-3_1024.3415a173.webp";